import { Language } from '^/types';

export default {
  hillshadeMultiplyToggleText: {
    [Language.KO_KR]: '음영기복도',
    [Language.EN_US]: 'Hillshade',
  },
};
